import { inspectPin } from '../inspectPin'

export function removeInspectPin() {
  // Object.assign is required otherwise Valtio won't update the atom
  Object.assign(inspectPin, { pin: undefined })
}
